var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full md:py-0 py-2",class:_vm.iconRight ? 'justify-end' : 'justify-start '},[_c('div',{staticClass:"flex items-center",class:_vm.iconRight ? 'flex-row inputIconRight' : 'flex-row-reverse'},[_vm._t("icon"),_vm._v(" "),_vm._t("input")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }